import a from "./guahuabihua.vue2.js";
import "./guahuabihua.vue3.js";
import o from "../../../../_virtual/_plugin-vue_export-helper.js";
const m = /* @__PURE__ */ o(a, [["__scopeId", "data-v-6a84279f"]]);
export {
  m as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/components/configuration-goods/components/guahuabihua/guahuabihua.vue.js
// module id = 1255
// module chunks = 67